export default __webpack_public_path__ + "static/9-905c9f51c3f49d16f4d748fb5764a384.png";